import React from 'react';
import Skeleton from 'react-loading-skeleton';

import './EfakturaSelectListSkeleton.scss';

type Props = {
    count?: number;
};

const EfakturaSelectListSkeleton: React.FC<Props> = ({ count = 2 }) => {
    return (
        <>
            <div className="efaktura-sharing__select-list-skeleton">
                <h2>
                    <Skeleton width={200} height={40} />
                </h2>
                {Array.from(Array(count)).map((_, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <article key={`efaktura-sharing__seleect-list-${index}`} className="sgw-link-card">
                        <Skeleton className="sgw-link-card__link--skeleton" height={36} />
                    </article>
                ))}
            </div>
        </>
    );
};

export default EfakturaSelectListSkeleton;
